export default __webpack_public_path__ + "static/new-funnel-dark-mode-cf35974333c38c3cfef7e44b4d39ca11.mp4";